import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import './Stats.css';

const stats = [
  { value: 75, suffix: 'k+', label: 'Meeting rooms booked' },
  { value: 100, suffix: 'k+', label: 'Desks booked' },
  { value: 750, suffix: 'k+', label: 'Access Control Events' },
  { value: 150, suffix: 'k+', label: 'Visitors managed' },
  { value: 7.2, suffix: 'Mn+', label: 'Tech enabled Sq. feet', decimals: 1 },
  { value: 40, suffix: 'k+', label: 'Active users' },
];

function StatItem({ stat }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className="stat-item" ref={ref}>
      <div className="stat-number">
        {inView && (
          <CountUp
            end={stat.value}
            duration={3}
            decimals={stat.decimals || 0}
          />
        )}
        <span className="stat-suffix">{stat.suffix}</span>
      </div>
      <p className="stat-label">{stat.label}</p>
    </div>
  );
}

function Stats() {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, i) => (
            <StatItem key={i} stat={stat} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
